var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeTrailsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 179,
    viewBox: "0 0 370 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1348_3651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.984,
    cy: 113.5,
    rx: 146,
    ry: 26.5,
    fill: "url(#paint0_linear_1348_3651)",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.639 1L242.66 7.59508",
    stroke: "#3361CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.643 2.88477L249.642 9.16857",
    stroke: "#3361CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.311 12.939L253.643 14.824",
    stroke: "#3361CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9839 40.5L126.484 17.5V40.5H96.9839Z",
    fill: "#3361CF",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.984 40L243.984 17V40H269.984Z",
    fill: "#3361CF",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.234 17.75V64C243.234 66.3472 241.331 68.25 238.984 68.25H130.984C128.637 68.25 126.734 66.3472 126.734 64V17.75H243.234Z",
    stroke: "#3361CF",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.734,
    y: 26.75,
    width: 33.5,
    height: 7.5,
    rx: 3.75,
    fill: "white",
    stroke: "#3361CF",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -103.016,
    y: -160,
    width: 575,
    height: 467
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(100px)",
      clipPath: "url(#bgblur_0_1348_3651_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    "data-figma-bg-blur-radius": 200,
    d: "M271.234 40.75V102C271.234 104.347 269.331 106.25 266.984 106.25H101.984C99.6367 106.25 97.7339 104.347 97.7339 102V40.75H271.234Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "#3361CF",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.508 61.207L162.984 71.7312",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.984 61.207L173.508 71.7312",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M204.217 61L193.693 71.5242",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M193.693 61L204.217 71.5242",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.535 87.4921C175.92 82.8878 187.255 76.4417 197.516 87.4921",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1348_3651",
    x: 0.713097,
    y: 48.7292,
    width: 368.542,
    height: 129.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1354,
    result: "effect1_foregroundBlur_1348_3651"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1348_3651_clip_path",
    transform: "translate(103.016 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.234 40.75V102C271.234 104.347 269.331 106.25 266.984 106.25H101.984C99.6367 106.25 97.7339 104.347 97.7339 102V40.75H271.234Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1348_3651",
    x1: 184.984,
    y1: 107,
    x2: 184.984,
    y2: 130.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTrailsEmpty);
export default __webpack_public_path__ + "static/media/time_trails_empty.057c9cbb6e01672c695863cf717dc3b6.svg";
export { ForwardRef as ReactComponent };